/* eslint-disable no-console */
import { useOidc } from '@axa-fr/react-oidc';
// import { useOidcUser } from '@axa-fr/react-oidc';
import React, { useEffect } from 'react';
// import Layout from '../Layout'
import Layout from '../components/layout';
// import { DisplayIdToken } from './DisplayIdToken'
// import { DisplayUserInfo } from './DisplayUserInfo'

const Home = () => {
  const { login, isAuthenticated } = useOidc();
  // const { idToken, idTokenPayload } = useOidcIdToken();
  // const { oidcUser, oidcUserLoadingState } = useOidcUser();
  useEffect(() => {
    if (localStorage.getItem('appWiz')) {
      localStorage.removeItem('appWiz');
    }
  }, []);
  return (
    <Layout>
      {/* {!isAuthenticated && <button onClick={() => login('/admin')}>Login</button>} */}

      {/* {isAuthenticated &&
                <button onClick={() => logout()}>Logout</button>
            } */}

      {/* {!isAuthenticated && login('/userinfo')} */}
      {/* {alert(isAuthenticated)} */}
      {/* {isAuthenticated ? login('/recent-files-list') : login('/sign-in')} */}
      {/* {!isAuthenticated && login('/sign-in')} */}

      {!isAuthenticated && login('/recent-files-list')}
      {isAuthenticated && login('/recent-files-list')}
      {/* {!isAuthenticated && login('/recent-files-list')} */}

      {/* {idToken &&
        <p>
          <div className="card-body">
            <h5 className="card-title">ID Token</h5>
            <p className="card-text">{JSON.stringify(idToken)}</p>
            {idTokenPayload != null && <p className="card-text">{JSON.stringify(idTokenPayload)}</p>}
          </div>
        </p>
      } */}
    </Layout>
  );
};

export default Home;

// /* eslint-disable react/jsx-no-useless-fragment */
// /* eslint-disable prettier/prettier */
// import React, { Component } from 'react';
// // import logo from './logo.svg'
// import './Home.css';
// import { connect } from 'react-redux';
// import cognitoUtils from '../lib/cognitoUtils';
// // import request from 'request'
// // import appConfig from '../config/app-config.json'

// const mapStateToProps = (state) => {
//   return { session: state.session };
// };

// class Home extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       // apiStatus: 'Not called'
//     };
//     const {
//       session: { isLoggedIn },
//     } = this.props;
//     if (!isLoggedIn) {
//       cognitoUtils.getCognitoSession();
//       window.location.href = cognitoUtils.getCognitoSignInUri();
//       cognitoUtils.parseCognitoWebResponse(window.location.href);

//     }
//   }

//   // componentDidMount() {
//   //   if (this.props.session.isLoggedIn) {
//   //     // Call the API server GET /users endpoint with our JWT access token
//   //     const options = {
//   //       url: `${appConfig.apiUri}/users`,
//   //       headers: {
//   //         Authorization: `Bearer ${this.props.session.credentials.accessToken}`
//   //       }
//   //     }

//   //     this.setState({ apiStatus: 'Loading...' })
//   //     request.get(options, (err, resp, body) => {
//   //       let apiStatus, apiResponse
//   //       if (err) {
//   //         // is API server started and reachable?
//   //         apiStatus = 'Unable to reach API'
//   //         console.error(apiStatus + ': ' + err)
//   //       } else if (resp.statusCode !== 200) {
//   //         // API returned an error
//   //         apiStatus = 'Error response received'
//   //         apiResponse = body
//   //         console.error(apiStatus + ': ' + JSON.stringify(resp))
//   //       } else {
//   //         apiStatus = 'Successful response received.'
//   //         apiResponse = body
//   //       }
//   //       this.setState({ apiStatus, apiResponse })
//   //     })
//   //   }
//   // }

//   // onSignOut = (e) => {
//   //   e.preventDefault();
//   //   cognitoUtils.signOutCognitoSession();
//   // };

//   render() {
//     return (
//     // <>
//     // {/* <Header session={this.props.session} />
//     //   <div className="Home">
//     //     <header className="Home-header">

//       //     </header>
//       //   </div> */}
//       //   <Flow />
//       // </>
//       <>
//         {/* <Header session={this.props.session} />
//       <Navigate to="/main" /> */}
//       </>
//     );
//   }
// }

// export default connect(mapStateToProps)(Home);
